import {styled} from "@mui/system";
import Badge, {BadgeProps} from "@mui/material/Badge";

const StyledBadge = styled((props: BadgeProps) => <Badge {...props} />)(({theme}) => ({
    "& .MuiBadge-badge": {
        backgroundColor: theme.palette.error.main,
        color: "#FFFFFF",
        fontSize: "0.6875rem",
        minWidth: "17px",
        height: "17px",
        right: "3px",
        borderRadius: "7px",
    },
}));

export default StyledBadge;